import React from "react";
import classnames from "classnames";

import { defaultPageItems } from "@/helpers/apiPathHelpers";
import { FeedTypes } from "@/helpers/pageHelpers/Common/interface";
import { apiPath } from "@/helpers/apiPath";
import { renderFeedElement } from "@/containers/Feed/renderFeedElement";
import Container from "@/components/Container";
import { GridColumns } from "@/components/Container/Container.interface";
import Button from "@/components/Button";
import SkeletonLoader from "@/components/SkeletonLoader";
import PopularArticles from "@/components/PopularArticles";
import SectionHeading from "@/components/SectionHeading";
import SidebarAd from "@/components/Advertisement/Sidebar";
import MetaHead from "@/components/MetaHead";
import { articlesFeedMetaData } from "@/helpers/pageMetaData";
import { usePagination } from "@/helpers/usePagination";
import EmptyState from "@/components/EmptyState";
import { SubheadingVariant } from "@/components/EmptyState/EmptyState.interface";

import styles from "../Feed.module.scss";

//TODO: probably unused, can be removed
const PersonalizedArticles = () => {
  const {
    isEmpty,
    elements,
    isLoadingMore,
    isLoadingInitialData,
    isReachingEnd,
    loadMore,
  } = usePagination([], defaultPageItems.SPECIFIC_FEED, (index) =>
    apiPath.PERSONAL_FEED_ARTICLES({ page: index + 1 })
  );

  let advertisementIndex = 0;

  return (
    <>
      <MetaHead metaData={articlesFeedMetaData} />
      <div
        className={classnames(
          styles.feedContainer,
          styles.personalFeedContainer
        )}
      >
        <Container grid={GridColumns.Twelve}>
          <div className={styles.feedTiles}>
            {isEmpty ? (
              <EmptyState
                heading="Wygląda na to, że nie masz tu jeszcze żadnych treści."
                withIcon
                variant={SubheadingVariant.PersonalFeed}
                className={styles.personalFeedEmptyState}
              />
            ) : (
              <SectionHeading title="Najnowsze" />
            )}

            {elements.map((element, index) => {
              if (element.type === FeedTypes.Ad) {
                advertisementIndex++;
              }
              return renderFeedElement(
                element.type,
                element.object,
                advertisementIndex,
                index
              );
            })}

            {isLoadingMore && <SkeletonLoader />}

            {elements.length > 0 && !isReachingEnd && !isLoadingInitialData && (
              <Button
                variant="secondary"
                onClick={loadMore}
                className={styles.loadMore}
              >
                {isLoadingMore ? "Wczytuję..." : "Więcej artykułów"}
              </Button>
            )}
          </div>

          <div className={styles.popularArticles}>
            <PopularArticles />
            <SidebarAd />
          </div>
        </Container>
      </div>
    </>
  );
};

export default PersonalizedArticles;
